import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=93f8c4b6&"
import script from "./LayoutFull.vue?vue&type=script&lang=js&"
export * from "./LayoutFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93f8c4b6')) {
      api.createRecord('93f8c4b6', component.options)
    } else {
      api.reload('93f8c4b6', component.options)
    }
    module.hot.accept("./LayoutFull.vue?vue&type=template&id=93f8c4b6&", function () {
      api.rerender('93f8c4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-full/LayoutFull.vue"
export default component.exports